import { render, staticRenderFns } from "./VoipCaller.vue?vue&type=template&id=f2acdc5a&"
import script from "./VoipCaller.vue?vue&type=script&lang=js&"
export * from "./VoipCaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports